export default __webpack_public_path__ + "static/media/XVS.48ca0f78.svg";